<template>
  <div class="m-market-players">
    <template v-for="(item, index) in sortedMarkets">
      <div :key="index">
        <div class="m-title">
          {{ getPlayerName(item.outcomes.map[item.outcomes.order[0]].description) }}
        </div>
        <div
          v-if="item.outcomes.order && item.outcomes.order.length > 0"
          class="m-market-row"
        >
          <template v-for="id in item.outcomes.order">
            <Outcome
              :key="id"
              class="has-desc"
              :outcome="item.outcomes.map[id]"
              :market="item"
              :event="event"
              :description="getCustomDesc(item.outcomes.map[id].description)"
              show-desc
            />
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
/**
 * 聚合显示 players 作为副标题
 */
import Outcome from 'wap/match/Event/pagelet/Outcome'
import useMarket9Players from '@ms/components/market/useMarket9Players.js'

export default {
  components: {
    Outcome
  },
  props: {
    markets: {
      type: Array,
      default: () => []
    },
    event: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    const { getPlayerName, getCustomDesc, sortedMarkets } = useMarket9Players(props)

    return {
      getPlayerName,
      getCustomDesc,
      sortedMarkets
    }
  }
}
</script>

<style lang="less">
.m-market-players {
  .m-title {
    padding: 4px 0;
    margin: 12px 0;
    color: #ccc;
    font-size: 12px;
    line-height: 14px;
  }

  .m-market-row {
    flex-wrap: wrap;
    margin: 0 0 4px;

    .m-outcome {
      max-width: 32%;
      flex: 1 1 32%;
      margin: 0 4px 4px 0;

      &.active {
        .desc {
          color: #666;
        }
      }

      .desc {
        color: #999;
      }
    }
  }
}
</style>
